import axios from '@/utils/apiClient'

export function loadSelectionDetails (listId) {
  return axios.get(`/lists/${listId}.json`)
}

export function startNetxListSync (listId) {
  return axios.post('/netx/list_sync_runs', { list_id: listId })
}

export function loadNetxListSyncRun (runId) {
  return axios.get(`/netx/list_sync_runs/${runId}`)
}

export function loadLatestNetxListSyncRun (listId) {
  return axios.get('/netx/list_sync_runs', { params: { list_id: listId } })
}

export function retryNetxListSyncRun (runId) {
  return axios.post(`/netx/list_sync_runs/${runId}/retry_failed`)
}

export function generateNetxWebsiteMedia (runId) {
  return axios.post(`/netx/list_sync_runs/${runId}/generate_website_media`)
}

export function listSyncError (error) {
  return (error.response && error.response.data && error.response.data.error) ||
    'The NetX selection sync could not be started.'
}



// WEBPACK FOOTER //
// ./src/utils/netxListSync.js